import React from 'react';
import { useTrackPage } from '@ion/api';
import TransformationLibTable from './TransformationLibTable';
import { TransformationLibTableContextProvider } from './TransformationLibTable/TransformationLibTableContext';
import { DrawerContextProvider } from 'app/shared/contexts/drawer';
import TransformationLibDrawer from 'app/clusters/TransformationLibTab/TransformationLibTable/TransformationLibDrawer';

function TransformationLibTab() {
  useTrackPage('transformation_library_tab_viewed');

  return (
    <TransformationLibTableContextProvider>
      <DrawerContextProvider>
        <TransformationLibTable />
        <TransformationLibDrawer />
      </DrawerContextProvider>
    </TransformationLibTableContextProvider>
  );
}

export default TransformationLibTab;
